var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGavel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H12C12.55 21 13 21.45 13 22C13 22.55 12.55 23 12 23H2C1.45 23 1 22.55 1 22C1 21.45 1.45 21 2 21ZM5.24 8.06999L8.07 5.23999L20.8 17.97C21.58 18.75 21.58 20.02 20.8 20.8C20.02 21.58 18.75 21.58 17.97 20.8L5.24 8.06999ZM13.73 2.40999L16.56 5.23999C17.34 6.01999 17.34 7.28999 16.56 8.06999L15.14 9.48999L9.49 3.82999L10.9 2.41999C11.68 1.62999 12.95 1.62999 13.73 2.40999ZM3.83 9.47999L9.49 15.14L8.08 16.55C7.3 17.33 6.03 17.33 5.25 16.55L2.42 13.72C1.64 12.94 1.64 11.67 2.42 10.89L3.83 9.47999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.bd2f667d.svg";
export { ForwardRef as ReactComponent };